// /apps/patient/src/components/dashboard/ExerciseNowCard.tsx

import { Plus, Dumbbell } from 'lucide-react';

interface ExerciseNowCardProps {
  onPress?: () => void;
}

export function ExerciseNowCard({ onPress }: ExerciseNowCardProps) {
  const handlePress = () => {
    if (onPress) {
      onPress();
    } else {
      // TODO: Navigate to exercise creation flow when implemented
    }
  };

  return (
    <button
      onClick={handlePress}
      className="w-full bg-gradient-to-r from-primary to-primary/80 rounded-xl shadow-sm p-5 text-left hover:shadow-md transition-shadow"
    >
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="p-2 bg-white/20 rounded-lg">
            <Dumbbell className="h-5 w-5 text-white" />
          </div>
          <div>
            <h3 className="font-semibold text-white">Exercise Now</h3>
            <p className="text-sm text-white/80">Start an ad-hoc workout</p>
          </div>
        </div>
        <div className="p-2 bg-white/20 rounded-full">
          <Plus className="h-5 w-5 text-white" />
        </div>
      </div>
    </button>
  );
}
